<small
  *ngIf="formCtrl.errors?.minlength && (formCtrl.dirty || formCtrl.touched)"
  class="p-invalid"
>
  {{ errorMsg }}
</small>
